import "../css/style.scss";

// Our modules / classes
import MobileMenu from "./modules/MobileMenu";
import AriaNav from "./modules/AriaNav";
import DropdownMenu from "./modules/DropdownMenu";
import Accordion from "./modules/Accordion";
import Form from "./modules/Form";
import HandleAlertBar from "./modules/handleAlert";
import DynamicHero from "./modules/dynamicHero";

// Instantiate a new object using our modules/classes
const mobileMenu = new MobileMenu();
const arianav = new AriaNav();
const accordion = new Accordion();
const dropdownmenu = new DropdownMenu();
const form = new Form();
const handleAlertBar = new HandleAlertBar();
const dynamicHero = new DynamicHero();
